export default __webpack_public_path__ + "static/media/ic_groups.b18454a0.svg";